import { isValidElement } from 'react';
export const getChildCardElementType = (child) => isValidElement(child) &&
    typeof child.type !== 'string' &&
    child.type.CARD_ELEMENT;
//# sourceMappingURL=getChildCardElementType.js.map